module.exports = __webpack_public_path__ + "static/media/Mesossomos v3.e7407a88.glb";